import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, IconButton, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useIsMobile from '../../hooks/useIsMobile'
import styles from './DrawerHeader.module.scss'

const DrawerHeader = ({
  title,
  subtitle,
  icon,
  actions,
  onClose,
  className = '',
  titleId
}) => {
  const isMobile = useIsMobile()

  return (
    <Box className={`${styles.drawerHeader} ${className}`}>
      <Box className={styles.drawerHeaderLeft}>
        <Typography className={styles.drawerTitle} id={titleId}>
          {icon && (
            <span className={styles.drawerTitleIcon}>
              {typeof icon === 'string' ? <FontAwesomeIcon icon={icon} /> : icon}
            </span>
          )}
          {title}
        </Typography>
        {subtitle && (
          <Typography className={styles.drawerSubtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box className={styles.drawerHeaderActions}>
        {actions}
        {isMobile ? (
          <Button
            className={styles.backButton}
            onClick={onClose}
            aria-label='go back'
            disableRipple
          >
            <FontAwesomeIcon icon='chevron-left' style={{ marginRight: 6 }} />
            Back
          </Button>
        ) : (
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label='close drawer'
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}

DrawerHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actions: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  titleId: PropTypes.string
}

export default DrawerHeader
